var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1DA0DB",
    d: "M27 .333C12.334.333.333 12.333.333 27c0 14.666 12 26.666 26.667 26.666s26.667-12 26.667-26.666S41.667.333 27 .333m0 48C15.24 48.333 5.667 38.76 5.667 27S15.24 5.666 27 5.666 48.334 15.24 48.334 27 38.76 48.333 27 48.333m12.24-33.12L21.667 32.786l-6.907-6.88-3.76 3.76 10.667 10.667L43 19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.37c8d3cd3c57ddcaa1289e2ec96120e4.svg";
export { ForwardRef as ReactComponent };